// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* line 1, node_modules\\bpmn-js-properties-panel\\styles\\header.less */
.bpp-properties-header {
  padding: 15px;
  padding-bottom: 5px;
}
/* line 5, node_modules\\bpmn-js-properties-panel\\styles\\header.less */
.bpp-properties-header > .label {
  font-size: 120%;
  font-weight: bolder;
}
/* line 10, node_modules\\bpmn-js-properties-panel\\styles\\header.less */
.bpp-properties-header > .search {
  display: none;
  margin-top: 5px;
  position: relative;
}
/* line 15, node_modules\\bpmn-js-properties-panel\\styles\\header.less */
.bpp-properties-header > .search input {
  position: relative;
  border-radius: 15px;
  width: 100%;
  z-index: 1;
}
/* line 22, node_modules\\bpmn-js-properties-panel\\styles\\header.less */
.bpp-properties-header > .search button {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  border: none;
  background-color: transparent;
  z-index: 2;
}
/* line 30, node_modules\\bpmn-js-properties-panel\\styles\\header.less */
.bpp-properties-header > .search button:before {
  content: '\\E805';
}
`, "",{"version":3,"sources":["webpack://./ModuleViews/Administration/BusinessProcesses/css/header.css"],"names":[],"mappings":"AAAA,qEAAqE;AACrE;EACE,aAAa;EACb,mBAAmB;AACrB;AACA,qEAAqE;AACrE;EACE,eAAe;EACf,mBAAmB;AACrB;AACA,sEAAsE;AACtE;EACE,aAAa;EACb,eAAe;EACf,kBAAkB;AACpB;AACA,sEAAsE;AACtE;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,UAAU;AACZ;AACA,sEAAsE;AACtE;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,6BAA6B;EAC7B,UAAU;AACZ;AACA,sEAAsE;AACtE;EACE,gBAAgB;AAClB","sourcesContent":["/* line 1, node_modules\\bpmn-js-properties-panel\\styles\\header.less */\n.bpp-properties-header {\n  padding: 15px;\n  padding-bottom: 5px;\n}\n/* line 5, node_modules\\bpmn-js-properties-panel\\styles\\header.less */\n.bpp-properties-header > .label {\n  font-size: 120%;\n  font-weight: bolder;\n}\n/* line 10, node_modules\\bpmn-js-properties-panel\\styles\\header.less */\n.bpp-properties-header > .search {\n  display: none;\n  margin-top: 5px;\n  position: relative;\n}\n/* line 15, node_modules\\bpmn-js-properties-panel\\styles\\header.less */\n.bpp-properties-header > .search input {\n  position: relative;\n  border-radius: 15px;\n  width: 100%;\n  z-index: 1;\n}\n/* line 22, node_modules\\bpmn-js-properties-panel\\styles\\header.less */\n.bpp-properties-header > .search button {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  border: none;\n  background-color: transparent;\n  z-index: 2;\n}\n/* line 30, node_modules\\bpmn-js-properties-panel\\styles\\header.less */\n.bpp-properties-header > .search button:before {\n  content: '\\E805';\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
